import React, { useEffect } from 'react';
import { useThemeStore } from '../../stores/themeStore';
import { useDensityStore } from '../../stores/densityStore';
import { useTablePreferencesStore } from '../../stores/tablePreferencesStore';

interface ConstructionThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Theme provider for the application.
 *
 * Everything renders through @billda/design-system tokens now — mode and
 * density are mirrored onto <html data-*> attributes, which the DS token
 * stylesheet reacts to. No MUI theme context remains.
 */
export const ConstructionThemeProvider: React.FC<
  ConstructionThemeProviderProps
> = ({ children }) => {
  const { mode, initializeTheme } = useThemeStore();
  const { density, initializeDensity } = useDensityStore();
  const { initializePreferences } = useTablePreferencesStore();

  useEffect(() => {
    initializeTheme();
    initializeDensity();
    initializePreferences();
  }, [initializeTheme, initializeDensity, initializePreferences]);

  // Mirror theme mode and density onto <html data-*> for DS tokens.
  useEffect(() => {
    document.documentElement.dataset.theme = mode;
  }, [mode]);

  useEffect(() => {
    document.documentElement.dataset.density = density;
  }, [density]);

  return <>{children}</>;
};
